<template>
  <div>
    <div class="details">
      <!--  <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="基本信息" name="first"> -->
      <el-row>
        <el-form>
          <div style="left: 550px;position: absolute;z-index: 3;">
            <el-button v-if="pageData.service_status == 2" style="margin-left: 20px;" type="danger"
              @click="handleDeleteOffLine()">删除
            </el-button>
            <el-button v-if="pageData.service_comment_status == 1" style="margin-left: 20px;" type="primary" @click="$refs.star.show({
							service_log_id: pageData.service_log_id,
							service_comment_level: pageData.comment_level,
							service_comment_id: pageData.service_comment_id
						})">评分
            </el-button>
          </div>
          <el-form-item label="区域名称：">{{ pageData.sign_area_name }}</el-form-item>
          <el-form-item label="服务对象名称：">{{ pageData.customer_name }}</el-form-item>
          <el-form-item label="服务人员：">{{ pageData.sign_nurse_name }}</el-form-item>
          <el-form-item label="居住地址：">{{ pageData.customer_current_address }}</el-form-item>
          <el-form-item label="签到地址：">{{ pageData.sign_address }}</el-form-item>
          <el-form-item label="签到时间：">{{ pageData.sign_time | formatDate }}</el-form-item>
          <el-form-item label="服务项目：">{{ pageData.service_project_name | project_name }}</el-form-item>
          <el-form-item label="开始服务时间：">{{ pageData.service_start_time | formatDate }}</el-form-item>
          <!-- <el-form-item label="最低服务时长："><span style="color: red;"
							v-if="pageData.service_project_duration">{{ pageData.service_project_duration | time }}</span>
					</el-form-item> -->
          <el-form-item label="服务时长：" v-if='pageData.service_status == 2'>
            <template v-if="pageData.service_end_time">
              {{ (pageData.service_end_time - pageData.service_start_time)/60 | time }}
            </template>
          </el-form-item>
          <el-form-item label="结束服务时间：" v-if='pageData.service_status == 2'>{{ pageData.service_end_time | formatDate }}</el-form-item>
          <el-form-item label="服务评价：">
            <el-rate v-if="pageData" style="position: relative;top: 9px;" disabled v-model="pageData.comment_level">
            </el-rate>
            <div v-if="pageData.service_comment_status == 1" style="padding-left: 80px;margin-top: 20px;">
              <div>
                {{ pageData.comment_content }}
              </div>
              <div v-if="pageData.comment_files && pageData.comment_files.length">
                <div style="display: inline-block;margin-right: 20px;margin-bottom: 20px;"
                  v-for="(item,i) in pageData.comment_files" :key="i">
                  <el-image v-if="item.type == 'image'" style="width: 300px; height: 300px" :src="item.url + '?imageMogr2/thumbnail/500x'"
                    @click="file = item;dialogVisible2=true;" fit="cover">
                  </el-image>
                  <video style="width: 300px; height: 300px;" controls v-if="item.type == 'video'"
                    :src="item.url"></video>
                </div>
              </div>
              <el-button type="primary" icon='el-icon-edit' size='mini' @click="replay" v-if="JudgeButton(role_permission,'record/replayComment')">回复评价</el-button>
            </div>
          </el-form-item>

          <el-form-item label="签退地址：" v-if='pageData.service_status == 2'>{{ pageData.sign_out_address }}</el-form-item>
          <el-form-item label="签退时间：" v-if='pageData.service_status == 2'>{{ pageData.sign_out_time | formatDate }}</el-form-item>
          <el-form-item label="服务状态：">
            <span v-if="pageData.service_status == 1">服务中</span>
            <span v-if="pageData.service_status == 2">已结束</span>
          </el-form-item>
          <el-form-item label="电话探访记录：">
            <div style="width: 70%;margin-left: 130px;">
              <el-form ref="elForm" inline>
                <el-form-item style="margin-right: 20px;">
                  <el-input v-model="query_log.abstract" placeholder="请输入记录摘要" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item style="margin-right: 20px;">
                  <el-button type="primary" icon="el-icon-search"
                    @click="query_log.flag='';query_log.page=1;list_log = [];getList()">查询
                  </el-button>
                </el-form-item>
                <el-form-item style="margin-right: 20px;" v-if="JudgeButton(role_permission,'record/callLogDelete')">
                  <el-button type="danger" :disabled="!multipleSelection.length" @click="delAll"
                    icon="el-icon-milk-tea"> 删除 </el-button>
                </el-form-item>
                <el-form-item v-if="JudgeButton(role_permission,'record/callLogExport')">
                  <el-button :disabled="!list_log.length" type="warning" icon="el-icon-upload" @click="handleExport">导出
                  </el-button>
                </el-form-item>
              </el-form>
              <el-table stripe border v-loading='loading_log' ref="multipleTable" :data="list_log" tooltip-effect="dark"
                @selection-change="handleSelectionChange">
                <el-table-column align='center' type="selection" width="55">
                </el-table-column>
                <el-table-column align='center' prop='user_name' label="社工姓名" width="120">
                </el-table-column>

                <el-table-column align='center' prop="add_time" label="创建时间" width="180">
                </el-table-column>
                <el-table-column align='center' prop="abstract" label="摘要" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align='center' label="文件">
                  <template slot-scope="scope">
                    <div class="file-list" v-if="scope.row.file">
                      <img @click="imgUrl=item;dialogVisible_log=true;" v-for="(item,i) in scope.row.file" :key="i"
                        :src="item" alt="">
                    </div>
                    <span v-else style="opacity: 0.5;">无</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align='center' width='100'>
                  <template slot-scope="scope" v-if="JudgeButton(role_permission,'record/callLogDelete')">
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                  </template>
                </el-table-column>

              </el-table>
              <el-pagination style="margin: 30px auto;text-align: center;" v-if="query_log.total > query_log.page_limit"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query_log.page"
                :page-size="query_log.page_limit" layout="total, prev, pager, next, jumper" :total="query_log.total">
              </el-pagination>
            </div>
          </el-form-item>
          <el-form-item :label="pageData.service_audit_status==3?'终审结果：':'审核结果：'"> <span
              :class="'state-'+pageData.service_audit_status">{{ pageData.service_audit_status | service_audit_status }}</span>
          </el-form-item>
          <el-form-item label="原 因：" v-if="pageData.service_audit_remark"><span
              style="color: #999999;">{{ pageData.service_audit_remark }}</span></el-form-item>
        </el-form>
        <div>
          <el-button v-if="JudgeButton(role_permission,'record/preCheckPass')" @click="type=4;check()" type="success" style="width: 112px;"> 预审合格 </el-button>
          <el-button v-if="JudgeButton(role_permission,'record/checkPass')" @click="type=1;check()" type="success" style="width: 112px;margin-left: 30px;"> 合格
          </el-button>
          <el-button v-if="JudgeButton(role_permission,'record/checkUnPass')" @click="dialogVisible1=true;type=2;" type="warning" style="width: 112px;margin: 30px;">不合格</el-button>
          <el-button @click="dialogVisible1=true;type=3;" type="danger" style="margin-left: 0;"
            v-if="JudgeButton(role_permission,'record/endCheckUnPass') && userInfo.role_id == 1">终审不合格</el-button>
        </div>
      </el-row>
      <!-- </el-tab-pane>
          <el-tab-pane label="跟进记录" name="second">
            <div class="details1">
                <div class="details1-1">
                    <el-date-picker
                      v-model="value2"
                      type="daterange"
					  @change="change"
					  value-format='yyyy-MM-dd'
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      >
                    </el-date-picker>
                    <el-button style="margin-left: 20px;" type="primary" @click="loading=true;query.page=1;getCustomerFollowUpLogList()">查询</el-button>
                </div>
                <div class="details1-2" style="margin-top: 20px;">
                    <el-table v-loading='loading' stripe border
                      :data="list">
                      <el-table-column align='center'
                        prop="create_time"
                        label="日期"
                        width="180">
                      </el-table-column>
                      <el-table-column align='center'
                        prop="founders"
                        label="服务人员"
                        width="180">
                      </el-table-column>
                      <el-table-column align='center'
                        prop="log_content" show-overflow-tooltip
                        label="跟进内容">
                      </el-table-column>
                    </el-table>
					<el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
					  @size-change="loading=true;getCustomerFollowUpLogList()"
					  @current-change="loading=true;getCustomerFollowUpLogList()"
					  :current-page="query.page"
					  :page-sizes="[10, 20, 50, 100]"
					  :page-size="query.page_limit"
					  layout="total, sizes, prev, pager, next, jumper"
					  :total="query.total">
					</el-pagination>
                </div>
            </div>
          </el-tab-pane> -->
      <!-- </el-tabs> -->
    </div>

    <el-dialog title="评价回复" :visible.sync="dialogVisible" width="30%">

      <el-form ref="added" size="medium">
        <el-form-item label="评价回复内容：" required>
          <el-input type='textarea' rows='7' :maxlength='500' show-word-limit v-model="reply_content"
            placeholder="请输入回复内容" clearable style="width: 100%;">
          </el-input>
        </el-form-item>
        <el-button type="primary" @click="handelConfirm">提交回复</el-button>
      </el-form>
      <div v-if="commentList.length" style="margin-top: 30px;">
        <div class="item" v-for="(item,i) in commentList" :key="i">
          <div class="flexbox">
            <div>{{ item.reply_role_name }}: {{ item.reply_content }}</div>
            <i v-if="userInfo.uid == item.uid" class="el-icon-delete-solid" @click="del(item)"></i>
          </div>
          <div style="opacity: 0.6;">{{ item.reply_time }}</div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="审核不合格" :visible.sync="dialogVisible1" width="30%">
      <el-form>
        <el-form-item label="不合格原因：" required>
          <el-input type='textarea' rows='7' :maxlength='500' show-word-limit v-model="service_audit_remark"
            placeholder="请输入原因" clearable style="width: 100%;">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1=false">取消</el-button>
        <el-button type="primary" @click="check()">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="" :visible.sync="dialogVisible2" width="60%">
      <img v-if="file.type == 'image'" :src="file.url" style='width: 100%;display: block;' />
      <video controls v-if="file.type == 'video'" :src="file.url"></video>
    </el-dialog>
    <el-dialog title="" :visible.sync="dialogVisible_log" width="60%">
      <img :src="imgUrl" style='width: 100%;display: block;' />
    </el-dialog>
    <star ref='star' @success='getDetail'></star>
  </div>
</template>

<script>
  import star from './components/star.vue';
  import userInfoAPI from '@/api/api';
  export default {
    components: {
      star
    },
    name: 'serviceDetails',
    props: {},
    data() {
      return {
        loading: true,
        dialogVisible: false,
        dialogVisible2: false,
        file: '',
        id: '',
        activeName: 'first',
        pageData: '',
        value2: '',
        list: [],
        query: {
          page_limit: 10,
          page: 1,
          customer_id: '',
          start_date: '',
          end_date: '',
          total: 0
        },
        reply_content: '',
        service_audit_remark: '',
        commentList: [],
        dialogVisible1: false,
        userInfo: '',
        type: 1,


        multipleSelection: [],
        list_log: [],
        query_log: {
          cid: '',
          abstract: '',
          page_limit: 10,
          page: 1,
          flag: '', // 操作标志 export=数据导出
          total: 0,
          add_date: ''
        },
        dialogVisible_log: false,
        imgUrl: '',
        loading_log: true
      }
    },
    filters: {
      formatDate(str) {
        if (str) {
          let date = new Date(str * 1000);
          let year = date.getFullYear();
          let month = date.getMonth() + 1;
          month = month < 10 ? ('0' + month) : month;
          let day = date.getDate();
          day = day < 10 ? ('0' + day) : day;
          let h = date.getHours();
          h = h < 10 ? ('0' + h) : h;
          let m = date.getMinutes();
          m = m < 10 ? ('0' + m) : m;
          let s = date.getSeconds();
          s = s < 10 ? ('0' + s) : s;
          return year + '-' + month + '-' + day + ' ' + h + ':' + m + ':' + s;
        }
      }
    },
    created() {
      this.id = this.$route.query.id;
      if (this.id) this.getDetail()
      if (this.$route.query.date) this.query_log.add_date = this.$route.query.date
    },
    mounted() {},
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      }
    },
  methods: {
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      handelConfirm() {
        if (!this.reply_content.trim()) {
          this.$message({
            type: 'error',
            message: '请输入评价内容'
          });
          return
        }
        userInfoAPI.serviceCommentAdd({
          service_log_id: this.id,
          service_comment_id: this.pageData.service_comment_id,
          reply_content: this.reply_content,
        }).then((res) => {
          if (res.data.code == 0) {
            this.getCommentReplyList()
            this.reply_content = ''
            this.$message({
              type: 'success',
              message: res.data.msg
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      },
      check() {
        if ((this.type == 3 || this.type == 2) && !this.service_audit_remark.trim()) {
          this.$message({
            type: 'error',
            message: '请输入不合格原因'
          })
          return
        }
        userInfoAPI.serviceState({
          service_log_id: this.id,
          status: this.type,
          service_audit_remark: this.type != 1 ? this.service_audit_remark : ''
        }).then((res) => {
          if (res.data.code == 0) {
            this.service_audit_remark = ''
            this.dialogVisible1 = false
            this.getDetail()
            this.$message({
              type: 'success',
              message: res.data.msg
            });
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      },
      replay() {
        this.getCommentReplyList()
        this.dialogVisible = true
      },
      del(item) {
        this.$confirm('此操作将永久删除该评论, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.serviceCommentDel({
            reply_id: item.reply_id
          }).then((res) => {
            if (res.data.code == 0) {
              this.getCommentReplyList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$message({
                type: 'success',
                message: res.data.msg
              });
            }
          })
        })
      },
      change(e) {
        if (e) {
          this.query.start_date = e[0]
          this.query.end_date = e[1]
        } else {
          this.query.start_date = ''
          this.query.end_date = ''
        }
      },
      handleClick(tab, event) {

      },
      getCommentReplyList() { // 评价回复列表
        userInfoAPI.serviceCommentList({
          service_log_id: this.id,
          service_comment_id: this.pageData.service_comment_id,
          page_limit: 999,
          page: 1
        }).then((res) => {
          this.commentList = res.data.data.list || []
        })
      },
      getDetail() {
        userInfoAPI.serviceLogDetail({
          service_log_id: this.id
        }).then((res) => {
          res.data.data.comment_files = []
          if (res.data.data.comment_file_path) {
            let lastInx, suffix;
            res.data.data.comment_file_path.forEach(item => {
              lastInx = item.lastIndexOf('.') + 1;
              suffix = item.slice(lastInx, item.length);
              if (suffix == 'jpg' || suffix == 'jpeg' || suffix == 'png' || suffix ==
                'gif' || suffix == 'jfif' || suffix == 'bmp' || suffix == 'webp') {
                item = {
                  url: item,
                  type: 'image'
                }
              } else {
                item = {
                  url: item,
                  type: 'video'
                }
              }
              res.data.data.comment_files.push(item)
            })
          }
          this.pageData = res.data.data
          this.query.customer_id = res.data.data.customer_id
          this.query_log.cid = res.data.data.customer_id
          this.getList()
          // this.getCustomerFollowUpLogList()
          userInfoAPI.getUserInfo().then(res => {
            this.userInfo = res.data.data
          })
        })

      },
      getCustomerFollowUpLogList() {
        userInfoAPI.customerFollowUpLogList(this.query).then((res) => {
          if (res.data.code == 0) {
            this.list = res.data.data.list || []
            this.query.total = res.data.data.page.count || 0
          }
          this.loading = false
        })
      },


      handleExport() {
        this.query_log.flag = 'export';
        this.getList();
      },
      getList() {
        if (this.query_log.flag != 'export') this.loading_log = true
        userInfoAPI.serviceCallLog(this.query_log).then(res => {
          if (this.query_log.flag == 'export') {
            let blob = new Blob([res.data], {
              type: 'application/zip'
            })
            let objectUrl = URL.createObjectURL(blob)
            let link = document.createElement('a')
            link.href = objectUrl
            link.setAttribute('download', '通话记录')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(objectUrl)
          } else {
            this.list_log = res.data.data.list || []
            this.query_log.total = res.data.data.page.count || 0
          }
          this.loading_log = false
        }).catch(() => {
          this.loading_log = false
        })
      },
      handleSizeChange(val) {
        this.loading = true
        this.query_log.flag = '';
        this.query_log.page_limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.loading = true
        this.query_log.flag = '';
        this.query_log.page = val;
        this.getList();
      },
      handleSelectionChange(val) { //是否全选框框
        this.multipleSelection = val;
      },
      delAll() {
        this.$confirm('此操作将永久删除选中记录, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.serviceCallDel({
            call_log_id: this.multipleSelection.map(i => {
              return i.call_log_id
            }).join(',')
          }).then((res) => {
            if (res.data.code == 0) {
              this.getList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })
      },
      handleDelete(index, row) { //删除
        this.$confirm('此操作将永久删除该记录, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.serviceCallDel({
            call_log_id: row.call_log_id
          }).then((res) => {
            if (res.data.code == 0) {
              this.getList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })
      },
      handleDeleteOffLine() {
        this.$confirm('此操作将永久删除该记录, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.serviceLogDel({
            service_log_id: this.id
          }).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.$router.back()
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })
      },
    },

    beforeDestroy() {},
    destroyed() {}
  }
</script>
<style lang='scss' scoped>
  .el-form-item {
    margin-bottom: 10px;
  }

  .state-0 {
    color: #999999;
  }

  .state-1 {
    color: #00be00;
  }

  .state-2 {
    color: #e4be44;
  }

  .state-3 {
    color: red;
  }

  .file-list {
    img {
      width: 60px;
      height: 60px;
      border-radius: 6px;
      cursor: pointer;
      margin-right: 10px;
    }
  }

  .item {
    margin-bottom: 10px;

    .flexbox {
      justify-content: space-between;
      display: flex;

      i {
        cursor: pointer;

        &:hover {
          color: red;
        }
      }
    }
  }

  /*去掉tabs底部的下划线*/
  /deep/.el-tabs__nav-wrap::after {
    position: static !important;
  }

  .details {
    margin: 10px 30px 0 30px;
  }
</style>
